type StepTitleProps = {
  subtitle: string;
  title?: string;
  className?: string;
};
export const StepTitle: React.FC<StepTitleProps> = ({
  className,
  subtitle,
  title,
}) => {
  return (
    <div className={className}>
      {title ? <div className="tw-font-bold tw-text-v_blue-dark tw-text-3xl tw-mb-3">{title}</div> : <></>}
      <div className="tw-font-bold tw-text-v_blue-dark tw-text-xl tw-mb-4">{subtitle}</div>
    </div>
  );
};
